import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

const ENV = process.env;

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: ENV.REACT_APP_APPINSIGHTS_KEY,
    loggingLevelConsole: 2,
    autoTrackPageVisitTime: true,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
  },
});
appInsights.loadAppInsights();
export { reactPlugin, appInsights };
